import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {SectionWrapper, SectionSeperator} from './style'
import {KitImage} from './KitsSectionImage'
import {KitDesc} from './KitsSectionDescription'

export const Section = ({section}) =>  {
    return (
        <>
            <SectionWrapper larger={section.larger} imgID={section.id} bgColor={section.bgColor} wrapped={section.wrapped} img_first={section.img_first} wrapper_left={section.wrapper_left}>                
                <Container fluid>
                    <Row xs={1} md={2}>
                        <Col sm={{order: section.img_first ? 1 : 2}} lg={5}><KitImage imgID={section.id}/></Col>
                        <Col sm={{order: section.img_first ? 2 : 1}} lg={7}><KitDesc id={section.id} section={section} img_first={section.img_first} /></Col>
                    </Row>
                </Container>
            </SectionWrapper>
            {section.seperator ? <SectionSeperator/> : ''}
        </>
    )
}
